export const useLanguages = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const toLanguage = urlParams.get('lang') || 'ES';

    return toLanguage.toUpperCase();
};
